module.exports = __webpack_public_path__ + "static/img/logo.2166f915.png";